import { Badge } from "@/components/base/badges/badges";
import { IdentityVerificationEntityType } from "@fp/admin-api-client/types/identityVerificationEntityType.js";

interface IdentityVerificationEntityBadgeProps {
  entityType: IdentityVerificationEntityType | null | undefined;
  businessName?: string | null;
}

const entityTypeConfig: Record<
  IdentityVerificationEntityType,
  { label: string; color: "gray" | "indigo" }
> = {
  [IdentityVerificationEntityType.Individual]: { label: "Individual", color: "gray" },
  [IdentityVerificationEntityType.Business]: { label: "Business", color: "indigo" },
};

export const IdentityVerificationEntityBadge = ({
  entityType,
  businessName,
}: IdentityVerificationEntityBadgeProps) => {
  if (!entityType) return null;

  const config = entityTypeConfig[entityType];
  const trimmedBusinessName = businessName?.trim();
  const label =
    entityType === IdentityVerificationEntityType.Business && trimmedBusinessName
      ? `${config.label} — ${trimmedBusinessName}`
      : config.label;

  return (
    <Badge size="sm" color={config.color}>
      {label}
    </Badge>
  );
};
